import { gql } from '@apollo/client';

const schema = {
  bulk: {
    name: 'bulkImportProductShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation bulkImportProductShop(
        $file: Upload!
        $type: String!
        $shop_id: String
        $update_type: String
        $base_store_code: String
        $booth_stock_status: String
      ) {
        bulkImportProductShop(
          file: $file
          type: $type
          shop_id: $shop_id
          update_type: $update_type
          base_store_code: $base_store_code
          booth_stock_status: $booth_stock_status
        ) {
          messages
        }
      }
    `,
  },
  boothList: {
    name: 'booth',
    serviceName: 'shopadmin',
    query: gql`
      query {
        booth {
          data {
            code
            title
          }
        }
      }
    `,
  },
};

export default schema;
